import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import SettingsHeader from './SettingsHeader';
import { LoadingSpinner } from '@/components';
import { useFeatureGate } from '@statsig/react-bindings';
import { useUserContext } from '@/contexts/UserContext';
import clsx from 'clsx';
import UserManagement from './UserManagement/UserManagement';

const TagManagement = lazy(() => import('./TagManagement'));
const TokenManagement = lazy(() => import('./TokenManagement'));
const DeviceManagementPage = lazy(() => import('../DeviceManagementPage'));

export const SettingsPage = () => {
  const { value: enableApiTokens } = useFeatureGate('api_tokens');
  const { sidebarCollapsed } = useUserContext();
  return (
    <div className="bg-gray-50 w-full">
      {/* we can make the input text dynamic when there are other funcitons to display on the settings page, beyond just tags */}
      <Suspense fallback={<LoadingSpinner />}>
        <Switch>
          {enableApiTokens && (
            <Route exact path="/settings/tokens">
              <SettingsHeader headerText="Token Management" subText="Manage your API tokens" />
              <TokenManagement />
            </Route>
          )}
          <Route exact path="/settings/tags">
            <SettingsHeader
              headerText="Tags Management"
              subText="Manage your preferences and settings"
            />
            <TagManagement />
          </Route>
          <Route exact path="/settings/users">
            <SettingsHeader
              headerText="User Management"
              subText="Manage your users and their permissions"
            />
            <UserManagement />
          </Route>
          <Route exact path="/settings/devices">
            <SettingsHeader
              headerText="Devices Management"
              subText="Monitor and manage all sensors and hives deployed across your spaces."
            />
            <div
              className={clsx(
                'transition-all duration-300',
                !sidebarCollapsed ? 'w-[calc(100vw-260px)]' : 'w-[calc(100vw-56px)]',
              )}
            >
              <DeviceManagementPage />
            </div>
          </Route>
          <Redirect to="/settings/tags" />
        </Switch>
      </Suspense>
    </div>
  );
};

export default SettingsPage;
